import { Component, inject } from '@angular/core';

import { TranslationService } from '../../../shell/translation-service';
import { FatalErrorState } from '../fatal-error-state';

@Component({
  selector: 'ima-fatal-error-overlay',
  templateUrl: './fatal-error-overlay.html',
  styleUrl: './fatal-error-overlay.scss',
})
export class FatalErrorOverlay {
  protected readonly i18n = inject(TranslationService);
  protected readonly fatalErrorState = inject(FatalErrorState);

  protected reload(): void {
    location.reload();
  }
}
